import { useState } from 'react';

const footerLinks = [
  {
    title: "Servicios",
    links: [
      { label: "Limpieza de Casas", href: "#servicios" },
      { label: "Limpieza de Apartamentos", href: "#servicios" },
      { label: "Limpieza de Oficinas", href: "#servicios" },
      { label: "Move In / Move Out", href: "#servicios" },
    ],
  },
  {
    title: "Frecuencias",
    links: [
      { label: "Servicio Semanal", href: "#servicios" },
      { label: "Servicio Quincenal", href: "#servicios" },
      { label: "Servicio Mensual", href: "#servicios" },
      { label: "Servicio Único", href: "#servicios" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { label: "Cómo Funciona", href: "#como-funciona" },
      { label: "Testimonios", href: "#testimonios" },
      { label: "Trabaja con Nosotros", href: "#empleo" },
      { label: "Contacto", href: "#contacto" },
    ],
  },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone) return;
    setStatus('sending');
    try {
      const body = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      });
      const res = await fetch('https://readdy.ai/api/form/d79c3c3ll6jbq2vddleg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <footer className="bg-teal-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-teal-500 rounded-lg">
                <i className="ri-sparkling-2-line text-white text-lg"></i>
              </div>
              <div>
                <span className="font-bold text-lg leading-none block">Jek Cleaning</span>
                <span className="text-xs text-teal-400 leading-none">Service</span>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              Servicio profesional de limpieza para casas, apartamentos, oficinas y mudanzas. Tu espacio limpio, tu mente tranquila.
            </p>
            <div className="flex flex-col gap-3 mb-8">
              <a href="tel:+19046087529" className="flex items-center gap-2 text-sm text-white/70 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-phone-line text-teal-400"></i>
                904-608-7529
              </a>
              <a href="mailto:info@jekcleaning.com" className="flex items-center gap-2 text-sm text-white/70 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-mail-line text-teal-400"></i>
                info@jekcleaning.com
              </a>
              <a href="https://wa.me/19046087529" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-2 text-sm text-white/70 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-teal-400"></i>
                WhatsApp
              </a>
            </div>

            {/* Contact Form */}
            <div className="bg-white/5 rounded-lg p-5 border border-white/10">
              <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wide flex items-center gap-2">
                <i className="ri-send-plane-line text-teal-400"></i>
                Escríbenos
              </h4>
              {status === 'success' ? (
                <div className="flex flex-col items-center justify-center py-6 gap-2 text-center">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-500/20 rounded-full">
                    <i className="ri-check-line text-teal-400 text-xl"></i>
                  </div>
                  <p className="text-teal-400 text-sm font-medium">¡Mensaje enviado!</p>
                  <p className="text-white/50 text-xs">Te contactaremos pronto.</p>
                  <button
                    onClick={() => setStatus('idle')}
                    className="mt-2 text-xs text-teal-400 hover:text-teal-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Enviar otro mensaje
                  </button>
                </div>
              ) : (
                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-3"
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="Tu nombre"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/10 border border-white/15 rounded-md px-3 py-2 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Tu correo electrónico"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/10 border border-white/15 rounded-md px-3 py-2 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400 transition-colors"
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Tu número de teléfono"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full bg-white/10 border border-white/15 rounded-md px-3 py-2 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400 transition-colors"
                  />
                  <textarea
                    name="message"
                    placeholder="Tu mensaje (opcional)"
                    value={formData.message}
                    onChange={handleChange}
                    maxLength={500}
                    rows={3}
                    className="w-full bg-white/10 border border-white/15 rounded-md px-3 py-2 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400 transition-colors resize-none"
                  />
                  {status === 'error' && (
                    <p className="text-red-400 text-xs">Hubo un error. Intenta de nuevo.</p>
                  )}
                  <button
                    type="submit"
                    disabled={status === 'sending'}
                    className="w-full bg-teal-500 hover:bg-teal-400 disabled:opacity-60 text-white text-sm font-medium py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                  >
                    {status === 'sending' ? (
                      <>
                        <i className="ri-loader-4-line animate-spin"></i>
                        Enviando...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line"></i>
                        Enviar mensaje
                      </>
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wide">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                      className="text-white/55 hover:text-teal-400 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            &copy; {new Date().getFullYear()} Jek Cleaning Service. Todos los derechos reservados.
          </p>
          <p className="text-white/30 text-xs">
            Limpieza profesional · House cleaning near me · Cleaning services
          </p>
        </div>
      </div>
    </footer>
  );
}
